import $i18n from 'panda-i18n';
import React, { useEffect, useRef } from 'react';
import { useSetState, useLocalStorageState } from 'ahooks';
import { getWarehouseCode } from '@/utils';
import { State } from './index.interface';
import styles from './index.module.scss';
import { getLoginTime, getLoginDays, getHoliday } from './index.services';
import { Box, Icon } from '@fpxfd/next';

const HeaderContainer = () => {
  const [userInfo] = useLocalStorageState('user');
  const { empCode, empName }: any = userInfo || {};

  const [state, setState] = useSetState<State>({
    time: 0,
    day: 0,
    warehouseCode: getWarehouseCode(),
    isHoliday: false,
  });

  const timeRef: any = useRef();
  timeRef.current = state.time;

  const initDatas = () => {
    getLoginTime({ empCode, warehouseCode: state.warehouseCode }).then((res) => {
      setState({
        time: res,
      });
    });
  };

  // 获取数据
  useEffect(() => {
    const { warehouseCode } = state;
    getLoginDays({ empCode, warehouseCode }).then((res) => {
      initDatas();
      setState({
        day: res,
      });
    });
    getHoliday({ warehouseCode: getWarehouseCode() }).then((res) => {
      setState({
        isHoliday: res,
      });
    });
    const timer = setInterval(() => {
      initDatas();
    }, 10000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className={styles.bgContainer}>
      <div className={styles.bg}>
        <Box justify="center" className={styles.user} data-i18n-ignore-content>
          <p>
            {$i18n.get({ id: 'Hi.four_px', dm: '嗨' })} {empName}
          </p>
          <Box direction="row" className={styles.holidayTip} align="center">
            {state.isHoliday && (
              <>
                <Icon type="jiaqi" size="xs" style={{ color: '#fff', marginTop: '-3px' }} />
                <span>{$i18n.get({ id: 'HappyHoliday.four_px', dm: '假期愉快' })}</span>，
              </>
            )}
            {$i18n.get({ id: 'ThankYouForYourWorkPlease_2631003637.four_px', dm: '感谢您的工作，请记得劳逸结合' })}
          </Box>
        </Box>

        <Box direction="row" justify="center" className={styles.right}>
          <div className={styles.time}>
            <div>{timeRef.current}</div>
            <span>{$i18n.get({ id: 'WorkingHoursToday.four_px', dm: '今日工作时长' })}</span>
          </div>

          <div className={styles.time}>
            <div>{state.day}</div>
            <span>{$i18n.get({ id: 'DaysInUse.four_px', dm: '您已使用天数' })}</span>
          </div>
        </Box>
      </div>

      <div className={styles.computer} />
    </div>
  );
};

export default HeaderContainer;
